import tools from "../../tools";
//导入draggable组件
import draggable from 'vuedraggable'
import fa from "element-ui/src/locale/lang/fa";

export default {
    name: 'taskManagement',
    //注册draggable组件
    components: {
        draggable,
    },
    watch: {
        //如果路由发生了变化，更新页面数据
        $route(to, from) {
            if (to.path !== from.path) {
                if (this.exercisePoolId != this.$route.params.exercisePoolId) {
                    this.exercisePoolId = this.$route.params.exercisePoolId;
                }
                this.init();
            }
        }
    },
    data() {
        // 暴露模块
        let valiNameRepeat = (rule, value, callback) => {
            let json = {exercisePoolId: this.exercisePoolId, hteName: value, hteId: 0};
            if (this.isEditorPaperShow) {
                json.hteId = this.paperInfo.paperId
            }
            this.$tools.api(
                'ExercisePools.IsExistHtePoolHteNameAsync',
                json,
                function (res) {
                    if (res) {
                        callback(new Error('试卷名称不能重复'));
                    } else {
                        callback();
                    }
                }
            )
        };
        let validatorObj = {
            questioneName: [
                {required: true, message: '请输入试卷名称', trigger: 'blur'},
                {min: 0, max: 100, message: '已超出限制字数', trigger: 'blur'},
                {validator: valiNameRepeat, trigger: 'blur'},
            ],
            requires: [
                {required: true, message: '请至少选择一项', trigger: 'change'},
            ],
        };
        return {
            //试卷库id
            exercisePoolId: this.$route.params.exercisePoolId,
            //试卷库名称
            exercisePoolName: "",
            SubjectCourseId: "",
            SubjectCourseName: "",

            //下拉框--年级、标签、年份、地区
            tagList: [],
            gradesList: [],
            localList: [],
            localList2: [], //没有全部地区的数据
            localList_props: {
                checkStrictly: true,
                value: "LocaleId",
                label: "LocaleName",
                children: "Locales"
            },
            localList_create_props: {
                multiple: true,
                checkStrictly: true,
                value: "LocaleId",
                label: "LocaleName",
                children: "Locales"
            },
            yearList: [],
            searchlist: {
                gradeId: '',
                tagId: '',
                year: '',
                localList: ['']
            },

            //试卷列表
            paperList: [],
            isNothing: false, //是否空内容
            //左侧列表删除图标
            delIconShow: -1,

            //新建试卷弹窗
            isNewPaperShow: false,
            newPaperform: {
                paperName: '',
                gradesList: [],
                tipsList: [],
                yearsList: [],
                localList: []
            },
            questionRules: {
                paperName: validatorObj.questioneName,
                gradesList: validatorObj.requires,
                tipsList: validatorObj.requires,
                yearsList: validatorObj.requires,
                localList: validatorObj.requires,
            },

            //编辑试卷弹窗
            isEditorPaperShow: false,
            editorPaperform: {
                paperName: '',
                gradesList: [],
                tipsList: [],
                yearsList: [],
                localList: []
            },

            //单个试卷信息
            paperInfo: {
                paperId: "",
                paperName: "",
                paperExCount: 0,
                paperScore: 0,
                paperIsPublish: false,
            },
            //是否为空试卷
            paperEmpty: false,
            paperExerciseList: [],
            viewType: 0, //查看习题模式 0=精简，1=预览

            paperExerciseListByExerciseTypeAlias: [],
            paperExerciseId: 0,

            drag: false, //拖拽操作
            disabled: false,
            //习题视觉还原sdk的配置项
            config: {
                LazyLoad: false,
                BlankInnerText: '__[Num]__'
            },
            rightOptions: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'S', 'Y', 'Z'],
        }
    },
    // 组件实例创建后
    created() {
        this.$emit("header", false);
        this.$emit("footer", false);
        //加载latex
        // tools.GetLatexWebsite();
    },
    // 组件挂载完成
    mounted() {
        this.init();
    },
    updated() {
        this.$nextTick(function () {
            HexExerciseTransform.renderImage($(".exercise"), function () {
                // console.log("图片渲染完毕")
            });
        });
    },
    methods: {
        init() {
            this.getExercisePoolById();
            this.getTag();
            this.getGrades();
            this.getLocale();
            this.getYearList();
        },
        //获取试卷库信息
        getExercisePoolById() {
            let that = this;
            this.$tools.api(
                'ExercisePools.GetExercisePoolByHTEIdAsync',
                {HTEPaperid: that.exercisePoolId},
                function (res) {
                    that.exercisePoolName = res.ExercisePoolName;
                    that.SubjectCourseId = res.SubjectCourseId;
                    that.SubjectCourseName = res.SubjectCourseName;
                    that.GetSubjectBySubjectCourseID()
                }
            )
        },
       
        GetSubjectBySubjectCourseID() {
            let that = this
            tools.api('ExercisesPool.GetSubjectBySubjectCourseID', {
                "SubjectCourseId": that.SubjectCourseId
            }, (data) => {
                HexDrawExe.setFontFamily(data.SubjectType,'div.exercise')
                that.getHtePoolHte(this.$route.params.paperId);
            })
        },
        //获取四个下拉框
        getTag() {
            let that = this;
            this.$tools.api(
                'ExercisePools.GetPaperCharacteristics',
                {},
                function (res) {
                    if (res) {
                        that.tagList = res.map(item => {
                            return {
                                Key: parseInt(item.Key),
                                Name: item.Name,
                            }
                        });
                    }
                }
            )
        },
        getGrades() {
            let that = this;
            this.$tools.api(
                'ExercisePools.SearchGradesAsync',
                {},
                function (res) {
                    if (res) {
                        that.gradesList = res.map(item => {
                            return {
                                Key: item.gradeId,
                                Name: item.gradeName,
                            }
                        });
                    }
                }
            )
        },
        getLocale() {
            let that = this;
            this.$tools.api(
                'ExercisePools.GetLocaleAsync',
                {},
                function (res) {
                    if (res) {
                        that.localList = res;
                        that.localList2 = [].concat(res);
                        //需要加上全部地区
                        that.localList.unshift({
                            LocaleGrade: 1,
                            LocaleId: "",
                            LocaleName: "全部地区",
                            Locales: null,
                            ParentId: 0,
                        })
                    }
                }
            )
        },
        //获取年 2016至今
        getYearList() {
            const _this = this;
            let date = new Date;
            let year = date.getFullYear();
            _this.yearList = [];
            for (let i = year; i >= 2016; i--) {
                _this.yearList.push(i);
            }
        },
        //获取试卷库下所有试卷
        getHtePoolHte(papreid) {
            let that = this;
            let localeId = that.searchlist.localList[that.searchlist.localList.length - 1];
            this.$tools.api(
                'ExercisePools.GetHtePoolHteAsync',
                {
                    exercisePoolId: that.exercisePoolId,
                    gradeId: that.searchlist.gradeId,
                    tagId: that.searchlist.tagId,
                    year: that.searchlist.year,
                    localeId: localeId
                },
                function (res) {
                    if (res && res.length > 0) {
                        that.isNothing = false;
                        that.paperList = res;
                        if (that.paperList.length > 0) {
                            that.getHTEPaper(papreid);
                        }
                    } else {
                        that.isNothing = true;
                    }
                }
            )
        },
        //返回
        returnClose() {
            try {
                window.opener.location.reload();
            } catch (e) {

            }
            window.close();
        },

        //新建试卷
        newPaperShow() {
            this.isNewPaperShow = true;
        },
        goNewPaperformSend(formName) {
            this.$refs[formName].validate((valid) => {
                let that = this;
                let LoacleIds = [];
                for (let item of that.newPaperform.localList) {
                    LoacleIds.push(item[item.length - 1])
                }
                if (valid) {
                    this.$tools.api(
                        'ExercisePools.CreateHtePoolHteAsync',
                        {
                            ExercisePoolId: that.exercisePoolId,
                            HTEName: that.newPaperform.paperName,
                            GradeIds: that.newPaperform.gradesList,
                            TagIds: that.newPaperform.tipsList,
                            Years: that.newPaperform.yearsList,
                            LoacleIds: LoacleIds,
                        },
                        function (res) {
                            if (res != 0) {
                                that.$message({
                                    message: '添加试卷成功',
                                    type: 'success'
                                });
                                that.newPaperClose();
                                that.getHtePoolHte(res);

                                //滚动到新加的试卷
                                try {
                                    $(".paperList>ul").animate({scrollTop: $(".paperList>ul").get(0).scrollHeight}, 1000);
                                } catch (e) {
                                    console.log(e);
                                }
                            } else {
                                that.$message.error('添加试卷失败');
                            }
                        }
                    )
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        newPaperClose() {
            this.newPaperform.paperName = '';
            this.newPaperform.gradesList = [];
            this.newPaperform.tipsList = [];
            this.newPaperform.yearsList = [];
            this.newPaperform.localList = [];
            this.isNewPaperShow = false;
            this.$refs["newPaperform"].resetFields();
        },

        //编辑试卷
        editorPaperShow() {
            let that = this;
            if(this.paperInfo.paperIsPublish) {
                return false
            }
            this.$tools.api(
                'ExercisePools.GetHtepaperByIdAsync',
                {htePaperId: that.paperInfo.paperId},
                function (res) {
                    if (res) {
                        that.editorPaperform.paperName = res.HtepaperName;
                        that.editorPaperform.gradesList = res.GradeIds;
                        that.editorPaperform.tipsList = res.TagIds;
                        if (res.Years) {
                            that.editorPaperform.yearsList = res.Years.map(item => {
                                return parseInt(item)
                            });
                        } else {
                            that.editorPaperform.yearsList = res.Years;
                        }
                        let Loacles = [];
                        if (res.Loacles) {
                            for (let item of res.Loacles) {
                                Loacles.push(item.LocaleIds);
                            }
                        }
                        that.editorPaperform.localList = Loacles;
                        that.isEditorPaperShow = true;
                        that.$nextTick(function () {
                            this.$refs["editorPaperform"].resetFields();
                        })
                    }
                }
            )
        },
        goEditorPaperformSend(formName) {
            this.$refs[formName].validate((valid) => {
                let that = this;
                let LoacleIds = [];
                for (let item of that.editorPaperform.localList) {
                    LoacleIds.push(item[item.length - 1])
                }
                if (valid) {
                    this.$tools.api(
                        'ExercisePools.UpdateHtePoolHteAsync',
                        {
                            ExercisePoolId: that.exercisePoolId,
                            HTEId: that.paperInfo.paperId,
                            HTEName: that.editorPaperform.paperName,
                            GradeIds: that.editorPaperform.gradesList,
                            TagIds: that.editorPaperform.tipsList,
                            Years: that.editorPaperform.yearsList,
                            LoacleIds: LoacleIds,
                        },
                        function (res) {
                            if (res != 0) {
                                that.$message({
                                    message: '编辑试卷成功',
                                    type: 'success'
                                });
                                that.editorPaperClose();
                                that.getHtePoolHte(that.paperInfo.paperId);
                            } else {
                                that.$message.error('编辑试卷失败');
                            }
                        }
                    )
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        editorPaperClose() {
            let that = this;
            that.editorPaperform.paperName = '';
            that.editorPaperform.gradesList = [];
            that.editorPaperform.tipsList = [];
            that.editorPaperform.yearsList = [];
            that.editorPaperform.localList = [];
            that.isEditorPaperShow = false;
            this.$refs["editorPaperform"].resetFields();
        },

        //删除试卷
        deliconCtr(index) {
            this.delIconShow = index;
        },
        delPaper(id) {
            let that = this;
            this.$tools.api(
                'ExercisePools.DeleteHTEPaperAsync',
                {
                    ExercisePoolId: that.exercisePoolId,
                    HTEId: id,
                },
                function (res) {
                    if (res) {
                        that.$message({
                            message: '删除试卷成功',
                            type: 'success'
                        });
                        that.getHtePoolHte();
                    }
                }
            )
        },

        //试卷上下架
        updateHTEPaperPublishStatus(IsPublish) {
            let that = this;
            this.$tools.api(
                'ExercisePools.UpdateHTEPaperPublishStatusAsync',
                {
                    HTEId: that.paperInfo.paperId,
                    IsPublish: IsPublish
                },
                function (res) {
                    if (res) {
                        let message = "";
                        if (IsPublish) {
                            message = "试卷上架成功";
                        } else {
                            message = "试卷下架成功";
                        }
                        that.$message({
                            message: message,
                            type: 'success'
                        });
                        that.getHtePoolHte(that.paperInfo.paperId);
                    }
                }
            )
        },

        //获取试卷--切换试卷
        getHTEPaper(paperId) {
            let that = this;
            if (paperId) {
                that.paperInfo.paperId = paperId;
            } else {
                that.paperInfo.paperId = that.paperList[0].HteId;
            }
            let onePaperData = that.paperList.find(item => {
                return item.HteId == that.paperInfo.paperId;
            })
            that.paperInfo.paperName = onePaperData.HteName;
            that.paperInfo.paperExCount = onePaperData.IncludeExerciseCount;
            that.paperInfo.paperScore = onePaperData.Score;
            that.paperInfo.paperIsPublish = onePaperData.IsPublish;
            that.paperExerciseId = 0;
            that.getHTEPaperExercise();
        },
        //获取试卷里的习题
        getHTEPaperExercise(isScroll) {
            let that = this;
            that.paperExerciseListByExerciseTypeAlias = [];
            this.$tools.api(
                'ExercisePools.GetHTEPaperToExerciseIDAsync',
                {
                    HTEPaperid: that.paperInfo.paperId,
                },
                function (res) {
                    if (res && res.length > 0) {
                        that.paperEmpty = false;

                        //按照习题别名分类
                        res.forEach(function (item) {
                            let isSave = false;
                            that.paperExerciseListByExerciseTypeAlias.forEach(function (ExerciseTypeAliasItem) {
                                if (ExerciseTypeAliasItem.ExerciseTypeAliasId == item.ExerciseTypeAliasId) {
                                    isSave = true;
                                }
                            })
                            if (!isSave) {
                                that.paperExerciseListByExerciseTypeAlias.push({
                                    ExerciseTypeAliasId: item.ExerciseTypeAliasId,
                                    ExerciseTypeAliasName: item.ExerciseTypeAliasName,
                                    ExerciseList: res.filter(ex => {
                                        return ex.ExerciseTypeAliasId == item.ExerciseTypeAliasId;
                                    })
                                })
                            }
                        })
                        //给题类里的习题加序号
                        let i = 1;
                        that.paperExerciseListByExerciseTypeAlias.forEach(function (item) {
                            item.ExerciseList.forEach(function (ex) {
                                ex.Index = i;
                                i++;
                            })
                        })

                        //没有题则选中第一道
                        if (that.paperExerciseId == 0) {
                            that.paperExerciseId = res[0].ExerciseId;
                        }
                        //分数和数量一直对不上，还是前端计算吧
                        that.paperInfo.paperExCount = res.length;
                        that.paperInfo.paperScore = 0;
                        res.forEach(function (item) {
                            that.paperInfo.paperScore += item.Score;
                        });

                        that.getExerciseInfoList(res, isScroll);
                    } else {
                        that.paperEmpty = true;
                        that.paperInfo.paperExCount = 0;
                        that.paperInfo.paperScore = 0;
                    }
                }
            )
        },
        //获取答案，题解等信息
        getExerciseInfoList: function (ExerciseList, isScroll) {
            let _this = this;

            let ids = [];
            ExerciseList.forEach(function (item) {
                ids.push(item.ExerciseId)
            })
            _this.paperExerciseList = [];
            let paperExerciseList1 = []
            tools.api('Exercise.ExerciseList', {"ids": ids.join(",")}, (data) => {
                data.forEach(function (item) {
                    //给子题补充KeyPointName属性
                    if (item.Questions != undefined && item.Questions.length > 0) {
                        item.Questions.forEach(function (Questions) {
                            Questions.KeyPointName = "";
                        })
                    }

                    //使用试卷的分数
                    let extend = ExerciseList.find(el => {
                        return el.ExerciseId == item.ExerciseId
                    })
                    item.Score = extend.Score;

                    //显示答案
                    if (item.ET == "Choice") {
                        _this.GetChoiceAnswerStrByContent(item);
                    } else if (item.ET == "FillBlank") {
                        _this.GetFillBlankAnswersStr(item);
                    } else if (item.ET == "ChoiceFillBlank") {
                        _this.GetChoiceFillBlankAnswersStr(item);
                    } else if (item.ET == "Compute" || item.ET == "LargeChoiceFillBlank") {
                        item.Questions.forEach(function (Questions) {
                            //使用试卷的分数
                            if (extend.ExerciseDto) {
                                let subextend = extend.ExerciseDtos.find(el => {
                                    return el.ExerciseId == Questions.ExerciseId
                                })
                                Questions.Score = subextend.Score;
                            }

                            if (Questions.ET == "Choice") {
                                _this.GetChoiceAnswerStrByContent(Questions);
                            } else if (Questions.ET == "FillBlank") {
                                _this.GetFillBlankAnswersStr(Questions);
                            } else if (Questions.ET == "ChoiceFillBlank") {
                                _this.GetChoiceFillBlankAnswersStr(Questions);
                            }
                        })
                    }
                    // _this.paperExerciseList.push(HexExerciseTransform.jsonTransform(item));
                    paperExerciseList1.push(item)
                })
                _this.drawExerciseList(paperExerciseList1).then((data) => {
                    _this.paperExerciseList = tools.cloneJson(data) 
                })
                //  //渲染latex
                // _this.$nextTick(function () {
                //     tools.initLatex($(".exercise"));
                //     tools.initImg($(".exercise"));
                // })

                if (_this.viewType == 1) {
                    _this.getExerciseKeyPointList(_this.paperExerciseList);
                }

                
                //习题列表滚动位置
                if (_this.paperExerciseId && isScroll) {
                    _this.$nextTick(function () {
                        $(".paperExType>.exlist").animate({scrollTop: $(".oneexercise[hex-exerciseId=" + _this.paperExerciseId + "]").offset().top - $(".paperExType>.exlist").offset().top + $(".paperExType>.exlist").scrollTop()}, 800);
                        $(".paperdetal").animate({scrollTop: $(".exercise[hex-exerciseId=" + _this.paperExerciseId + "]").offset().top - $(".paperdetal").offset().top + $(".paperdetal").scrollTop()}, 800);
                    })
                }
            });
        },
        //获取选择题正确答案字符串
        GetChoiceAnswerStrByContent: function (Exercise) {
            Exercise.CorrectAnswerStr = "";
            if (Exercise.CorrectAnswer.length > 0) {
                Exercise.CorrectAnswerStr = "";
                var choiceanswer = Exercise.CorrectAnswer.split("");
                for (var i = 0; i < choiceanswer.length; i++) {
                    if (choiceanswer[i] == "1") {
                        Exercise.CorrectAnswerStr += "<div><span>" + String.fromCharCode(i + 65) + "、</span><div style='display: inline-block;max-width: 100%;'>" + Exercise.AnswersOptions[i] + "</div></div>";
                    }
                }
            }
        },
        //获取填空题正确答案字符串
        GetFillBlankAnswersStr: function (Exercise) {
            Exercise.FillBlankAnswersStr = [];
            Exercise.FillBlankAnswers.forEach(function (item) {
                var text = "";
                item.FillBlankAnswerOptions.forEach(function (temp) {
                    text += temp.Content + "、";
                })
                Exercise.FillBlankAnswersStr.push(text.toString().substring(0, text.length - 1));
            })
        },
        //获取选择填空题正确答案字符串
        GetChoiceFillBlankAnswersStr: function (Exercise) {
            Exercise.ChoiceFillBlankAnswersStr = [];
            Exercise.ChoiceFillBlankAnswers.forEach(function (item) {
                var text = "";
                item.ChoiceFillBlankAnswerOptions.forEach(function (temp) {
                    if (temp.IsAnswer) {
                        text += temp.Content + "、";
                    }
                })
                Exercise.ChoiceFillBlankAnswersStr.push(text.toString().substring(0, text.length - 1));
            })
        },
        //获取知识点
        getExerciseKeyPointList: function (ExerciseList) {
            let _this = this;
            let ids = [];
            ExerciseList.forEach(function (item) {
                ids.push(item.ExerciseId)
            })

            _this.getExerciseKeyPointListCommon(ids, function (KeyPointList) {
                ExerciseList.forEach(function (item) {
                    let KeyPoint = KeyPointList.find(el => {
                        return el.ExercixeId == item.ExerciseId
                    })
                    if (KeyPoint) {
                        item.KeyPointName = KeyPoint.KeyPointName;
                    }
                    //计算题还需要获取小题的知识点
                    if (item.ET == "Compute" || item.ET == "LargeChoiceFillBlank") {
                        let subExIds = [];
                        item.Questions.forEach(function (Questions) {
                            subExIds.push(Questions.ExerciseId);
                        })
                        _this.getExerciseKeyPointListCommon(subExIds, function (subKeyPointList) {
                            item.Questions.forEach(function (Questions) {
                                let subKeyPoint = subKeyPointList.find(el => {
                                    return el.ExercixeId == Questions.ExerciseId
                                })
                                if (subKeyPoint) {
                                    Questions.KeyPointName = subKeyPoint.KeyPointName;
                                }
                            })
                        })
                    }
                })
            })
        },
        getExerciseKeyPointListCommon: function (ExerciseIds, callback) {
            tools.api('Exercise.SearchKeyPointByExerciseIdsAsync', {"ExerciseIds": ExerciseIds}, (data) => {
                for (let item of data) {
                    item.KeyPointName = [];
                    for (let kp of item.KeyPointList) {
                        item.KeyPointName.push(kp.KeypointName);
                    }
                    item.KeyPointName = item.KeyPointName.join("、");
                }

                if (typeof callback == 'function') {
                    callback(data);
                }
            });
        },
        changeViewType(viewType) {
            this.viewType = viewType;

            //预览模式，加载知识点
            if (this.viewType == 1) {
                this.getExerciseKeyPointList(this.paperExerciseList);
            }
        },

        //创建习题
        goPaperExerciseCreate() {
            this.$router.push("/questionManagement/paperexedit/" + this.exercisePoolId + "/" + this.paperInfo.paperId);
        },
        //编辑习题
        gotoPaperExerciseEdit(exerciseId) {
            this.$router.push("/questionManagement/paperexedit/" + this.exercisePoolId + "/" + this.paperInfo.paperId + "/" + exerciseId);
        },
        //删除习题
        removePaperExercise(exerciseId) {
            let that = this;
            tools.api('ExercisePools.RemoveHtePaperToExerciseAsync', {
                htePaperId: that.paperInfo.paperId,
                exerciseId: exerciseId
            }, (data) => {
                that.$message({
                    message: '删除习题成功',
                    type: 'success'
                });
                if (that.paperExerciseId == exerciseId) {
                    //如果删除当前选中的题，则从头开始
                    that.paperExerciseId = 0;
                    that.getHTEPaperExercise();
                } else {
                    that.getHTEPaperExercise(true);
                }
            });
        },

        //修改习题分数
        setExScore(one) {
            let that = this;
            let Exercise = {ExerciseId: one.ExerciseId, Score: one.Score};
            if (one.ExerciseDtos && one.ExerciseDtos.length > 0) {
                let ComputeScore = 0;
                one.ExerciseDtos.forEach(function (item) {
                    ComputeScore += item.Score
                })
                Exercise.Score = ComputeScore;
            }
            that.saveHtePaperExerciseCommon('update');
        },
        //保存习题公共方法
        saveHtePaperExerciseCommon: function (type) {
            let that = this;
            let Exercise = [];

            if (that.paperExerciseListByExerciseTypeAlias.length <= 0) {
                return false;
            }

            that.paperExerciseListByExerciseTypeAlias.forEach(function (ExType) {
                ExType.ExerciseList.forEach(function (item) {
                    let oneExercise = {ExerciseId: item.ExerciseId, Score: item.Score, ET: item.ET};
                    if (item.ExerciseDtos && item.ExerciseDtos.length > 0) {
                        oneExercise.Questions = [];
                        let ComputeScore = 0;
                        item.ExerciseDtos.forEach(function (sub) {
                            oneExercise.Questions.push({ExerciseId: sub.ExerciseId, Score: sub.Score})
                            ComputeScore += parseFloat(sub.Score)
                        })
                        oneExercise.Score = ComputeScore;
                    }
                    Exercise.push(oneExercise);
                })
            })

            tools.api('ExercisePools.SaveHtePaperAndExerciseAsync', {
                HtePaperId: that.paperInfo.paperId,
                exercises: Exercise,
                IsUseRecord:false
            }, (data) => {
                let message = '';
                if (type == "update") {
                    message = '修改习题成功';
                }
                if (type == "order") {
                    message = '习题调序成功';
                }
                that.$message({
                    message: message,
                    type: 'success'
                });
                that.getHTEPaperExercise(true);
            });
        },

        //编辑习题分数
        editExercise(one) {
            let that = this;
            that.paperExerciseId = one.ExerciseId;
            //习题列表滚动位置
            $(".paperdetal").animate({scrollTop: $(".exercise[hex-exerciseId=" + that.paperExerciseId + "]").offset().top - $(".paperdetal").offset().top + $(".paperdetal").scrollTop()}, 1000);
        },
        /**
         * 习题视觉还原(题数组)
         * @param needDrawExeList 需要转换的题数组
         */
        drawExerciseList(needDrawExeList) {
            return new Promise((resolve, reject) => {
            HexDrawExe.drawExerciseModel1List(needDrawExeList, this.config).then((exeList) => {
                for (let newData of exeList) {
                for (let realExe of needDrawExeList) {
                    if (newData.ExerciseId == realExe.ExerciseId) {
                        realExe.Note = newData.Explain
                        realExe.ExerciseSubject = newData.Subject;
                        realExe.AnswersOptions = newData.Options;
                        realExe.ChildExerciseHTMLStringList = newData.ChildExerciseHTMLStringList;
                    if (realExe.ET === 'Compute' || realExe.ET == "LargeChoiceFillBlank") {
                        //组合题小题
                        let childExercise = newData.ChildExerciseHTMLStringList;
                        for (let sonExe of realExe.Questions) {
                        for (let newSonExe of childExercise) {
                            if (sonExe.ExerciseId == newSonExe.ExerciseId) {
                                sonExe.ExerciseSubject = newSonExe.Subject;
                                sonExe.AnswersOptions = newSonExe.Options;
                                sonExe.Note = newSonExe.Explain
                                if(sonExe.ET === 'Choice') {
                                    sonExe.CorrectAnswer = newSonExe.Answer
                                } else if(sonExe.ET === 'FillBlank') {
                                    sonExe.FillBlankAnswers = newSonExe.Answer
                                } else if( sonExe.ET === 'Subjective') {
                                    sonExe.SubjectiveAnswer =  newSonExe.Answer
                                } else if(sonExe.ET === 'Judgment' ) {
                                    sonExe.CAnswer == newSonExe.Answer
                                } else if(sonExe.ET === 'ChoiceFillBlank') {
                                    sonExe.ChoiceFillBlankAnswers = newSonExe.Answer
                                }
                            }
                            
                        }
                        }
                    }
                    if(realExe.ET === 'Choice') {
                        realExe.CorrectAnswer = newData.Answer
                    } else if(realExe.ET === 'FillBlank') {
                        realExe.FillBlankAnswers = newData.Answer
                    } else if( realExe.ET === 'Subjective') {
                        realExe.SubjectiveAnswer =  newData.Answer
                    } else if(realExe.ET === 'Judgment' ) {
                        realExe.CAnswer == newData.Answer
                    } else if(realExe.ET === 'ChoiceFillBlank') {
                        realExe.ChoiceFillBlankAnswers = newData.Answer
                    }
                    }
                }
                }
                resolve(needDrawExeList);
            })
            })
        },

        //=========拖拽操作start========
        onStart(evt) {
            this.drag = true;
        },
        onEnd(e) {
            if(!(this.paperInfo.paperIsPublish || this.disabled)) {
                this.drag = false;
                //拖拽完成后，date里的数据顺序会改变
             
                this.saveHtePaperExerciseCommon('order');
            }
        },
        setDisabled(disabled) {
            this.disabled = disabled;
        },
        //=========拖拽操作end========

    },
}